import { ESolarAccountEsActions, SolarAccountEsActions } from "@edp-store/actions/ES/solar-account-es.actions";
import { ISolarAccountEsState, initialSolarAccountEsState } from "@edp-store/state/ES/solar-account-es.state";

export function SolarAccountEsReducers(
    state = initialSolarAccountEsState,
    action: SolarAccountEsActions
): ISolarAccountEsState {
    switch (action.type) {
        case ESolarAccountEsActions.SetSolarAccountEs: {
            return {
                ...state,
                solarAccountEs: action.payload
            };
        }
        case ESolarAccountEsActions.SetAccountAPIError: {
            return {
                ...state,
                lastAPIError: action.payload
            };
        }
        default:
            return state;
    }
}
